import { z } from "zod/v4";

export const EnvironmentVarsSchema = z.record(z.string(), z.string());
export type EnvironmentVars = z.infer<typeof EnvironmentVarsSchema>;

export type EnvironmentColor = "gray" | "red" | "orange" | "yellow" | "green" | "blue" | "purple";

const KNOWN_ENV_COLORS: Record<string, EnvironmentColor> = {
	default: "gray",
	prod: "red",
	production: "red",
	staging: "orange",
	stage: "orange",
	dev: "green",
	development: "green",
	local: "green",
	test: "blue",
	testing: "blue",
};

const HASH_COLORS: EnvironmentColor[] = ["blue", "purple", "yellow", "orange", "green"];

export const getEnvironmentColor = (name: string): EnvironmentColor => {
	const lower = name.toLowerCase();
	if (lower in KNOWN_ENV_COLORS) {
		return KNOWN_ENV_COLORS[lower];
	}

	let hash = 0;
	for (let i = 0; i < name.length; i++) {
		hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
	}
	return HASH_COLORS[hash % HASH_COLORS.length];
};
